import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '../../common';
import { useAdminAuth } from '../hooks';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * AdminProtectedRoute - Route guard for admin pages
 * Checks if user has admin or superadmin role
 */
export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAdmin, isLoading } = useAdminAuth();
  const token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refreshToken');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a]">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (!token || !refreshToken || !isAdmin) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
